import SectionContainer from '@/components/shared/SectionContainer';
import { QueryBoundary } from '@/components/ui/QueryBoundary';
import { SafeLink } from '@/components/ui/SafeLink';
import { Box, Button } from '@skin-seoul/design-system';
import SectionHeader from '../../components/SectionHeader';
import BestSellersList from './SkinSeoulSelectsList';
import { ProductGridSkeleton } from '../../components/ProductGrid';
import { CLASSNAME } from '@skin-seoul/service';
const SkinSeoulSelectsSection = () => {
  return <SectionContainer containerInnerProps={{
    paddingY: {
      base: 8,
      tablet: 18
    },
    alignItems: 'stretch',
    gap: 6
  }} data-sentry-element="SectionContainer" data-sentry-component="SkinSeoulSelectsSection" data-sentry-source-file="SkinSeoulSelectsSection.tsx">
      <SectionHeader className={CLASSNAME.NOT_TRANSLATE} href="/collections/skinseoulselects/" title="SkinSeoul Selects" data-sentry-element="SectionHeader" data-sentry-source-file="SkinSeoulSelectsSection.tsx" />

      <QueryBoundary loadingFallback={<ProductGridSkeleton length={5} />} data-sentry-element="QueryBoundary" data-sentry-source-file="SkinSeoulSelectsSection.tsx">
        <BestSellersList data-sentry-element="BestSellersList" data-sentry-source-file="SkinSeoulSelectsSection.tsx" />
      </QueryBoundary>

      <Box textAlign="center" data-sentry-element="Box" data-sentry-source-file="SkinSeoulSelectsSection.tsx">
        <SafeLink href="/collections/skinseoulselects/" unstyled width={{
        base: '100%',
        tablet: '332px'
      }} data-sentry-element="SafeLink" data-sentry-source-file="SkinSeoulSelectsSection.tsx">
          <Button backgroundColor="transparent" border="1px solid" borderColor="primary.500" borderRadius="8px" color="primary.500" textStyle="paragraph.small" fontWeight="regular" height="48px" padding={4} width={{
          base: '100%',
          tablet: '332px'
        }} _hover={{
          backgroundColor: 'primary.50'
        }} _active={{
          backgroundColor: 'primary.500',
          color: 'generic.0'
        }} data-sentry-element="Button" data-sentry-source-file="SkinSeoulSelectsSection.tsx">
            View all
          </Button>
        </SafeLink>
      </Box>
    </SectionContainer>;
};
export default SkinSeoulSelectsSection;